import { useMutation, useQueryClient } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { API_URL } from '@/config';

export const revertToCheckpoint = async ({
  project_id,
  workflow_id,
  destination_version,
}: {
  project_id: string;
  workflow_id: string;
  destination_version: number;
}): Promise<any> => {
  const access_token = storage.getToken();

  if (!access_token || !project_id) {
    return;
  }

  try {
    const response = await axios.post(
      `${API_URL}/v2/project/${project_id}/checkpoint/${workflow_id}/switch`,
      {
        destination_version,
      }
    );
    return response;
  } catch (error) {
    // throw error;
  }
};

export const useRvertToCheckpoint = (projectId: string, config = {}) => {
  const { addNotification } = useNotificationStore();
  const queryClient = useQueryClient();

  return useMutation<
    any,
    Error,
    { project_id: string; workflow_id: string; destination_version: number }
  >({
    mutationFn: revertToCheckpoint,
    onError: (error: any) => {
      addNotification({
        type: 'error',
        title: 'Failed to revert to checkpoint',
        message: error?.response?.data?.data,
        delay: 6000,
      });
    },
    onSuccess: (data) => {
      if (data) {
        addNotification({
          type: 'success',
          title: 'Checkpoint Reverted',
        });
        queryClient.invalidateQueries(['workflowCheckpoints', projectId]);
        queryClient.invalidateQueries(['projectContent', projectId]);
      }
    },
    ...config,
  });
};
